import { Route, Routes } from 'react-router-dom';
import { Header } from '../shared/components/Header';
import { Footer } from '../shared/components/Footer';
import { FloatingWhatsApp } from '../shared/components/FloatingWhatsApp';
import { ScrollToTop } from '../shared/components/ScrollToTop';
import { InspectDeterrent } from '../shared/components/InspectDeterrent';
import { Home } from '../pages/Home/index';
import { About } from '../pages/About/index';
import { AnimalNutrition } from '../pages/AnimalNutrition/index';
import { CattleFeed } from '../pages/CattleFeed/index';
import { PigFeed } from '../pages/PigFeed/index';
import { Contact } from '../pages/Contact/index';
import { EdibleOils } from '../pages/EdibleOils/index';
import { OilDetail } from '../pages/OilDetail/index';
import { NotFound } from '../pages/NotFound/index';

import ForOurPeople from '../pages/ForOurPeople/index';
import ForOurPlanet from '../pages/ForOurPlanet/index';
import ForOurPerformance from '../pages/ForOurPerformance/index';
import CourageToCare from '../pages/CourageToCare/index';
import { Products } from '../pages/Products/index';
import { ProductDetailPage } from '../pages/ProductDetailPage/index';
import { AflatoxinControlledFeed } from '../pages/AflatoxinControlledFeed/index';

import { DealerPartnership } from '../pages/DealerPartnership/index';
import { FutureOils } from '../pages/FutureOils/index';
import { OurStory } from '../pages/OurStory/index';
import { ProductionSupply } from '../pages/ProductionSupply/index';
import { QualityResearch } from '../pages/QualityResearch/index';
import { FarmerCorner } from '../pages/FarmerCorner/index';
import { Sustainability } from '../pages/Sustainability/index';

import { CattleWeightCalculator } from '../pages/CattleWeightCalculator/index';
import { PigWeightCalculator } from '../pages/PigWeightCalculator/index';
import { Blog } from '../pages/Blog/index';
import { BlogDetail } from '../pages/BlogDetail/index';

export default function App() {
  return (
    <div className="min-h-screen bg-page text-charcoal">
      <InspectDeterrent />
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-purpose" element={<CourageToCare />} />
          <Route path="/courage-to-care" element={<CourageToCare />} />
          <Route path="/couragetocare" element={<CourageToCare />} />
          <Route path="/about" element={<About />} />

          <Route path="/our-story" element={<OurStory />} />

          <Route path="/animal-nutrition" element={<AnimalNutrition />} />
          <Route path="/animal-nutrition/cattle-feed" element={<CattleFeed />} />
          <Route path="/animal-nutrition/pig-feed" element={<PigFeed />} />
          <Route path="/cattle-feed" element={<CattleFeed />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:productId" element={<ProductDetailPage />} />
          <Route path="/edible-oils" element={<EdibleOils />} />
          <Route path="/edible-oils/:slug" element={<OilDetail />} />
          <Route path="/dealer-partnership" element={<DealerPartnership />} />

          <Route path="/quality-research" element={<QualityResearch />} />
          <Route path="/quality" element={<QualityResearch />} />
          <Route path="/farmer-corner" element={<FarmerCorner />} />
          <Route path="/aflatoxin-controlled-feed" element={<AflatoxinControlledFeed />} />
          <Route path="/production-supply" element={<ProductionSupply />} />
          <Route path="/manufacturing" element={<ProductionSupply />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/future-oils" element={<FutureOils />} />


          <Route path="/calculators/cattle" element={<CattleWeightCalculator />} />
          <Route path="/calculators/pig" element={<PigWeightCalculator />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/for-our-people" element={<ForOurPeople />} />
          <Route path="/for-our-planet" element={<ForOurPlanet />} />
          <Route path="/for-our-performance" element={<ForOurPerformance />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
